var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCardManagment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 13.5V58.5H9V13.5H63ZM63 9H9C7.80653 9 6.66193 9.47411 5.81802 10.318C4.97411 11.1619 4.5 12.3065 4.5 13.5V58.5C4.5 59.6935 4.97411 60.8381 5.81802 61.682C6.66193 62.5259 7.80653 63 9 63H63C64.1935 63 65.3381 62.5259 66.182 61.682C67.0259 60.8381 67.5 59.6935 67.5 58.5V13.5C67.5 12.3065 67.0259 11.1619 66.182 10.318C65.3381 9.47411 64.1935 9 63 9Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 22.5H13.5V27H29.25V22.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.5H13.5V36H22.5V31.5Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 40.5H38.25C36.4598 40.5 34.7429 41.2112 33.477 42.477C32.2112 43.7429 31.5 45.4598 31.5 47.25V51.75H36V47.25C36 46.6533 36.2371 46.081 36.659 45.659C37.081 45.237 37.6533 45 38.25 45H51.75C52.3467 45 52.919 45.237 53.341 45.659C53.7629 46.081 54 46.6533 54 47.25V51.75H58.5V47.25C58.5 45.4598 57.7888 43.7429 56.523 42.477C55.2571 41.2112 53.5402 40.5 51.75 40.5Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 38.25C46.78 38.25 48.5201 37.7222 50.0001 36.7332C51.4802 35.7443 52.6337 34.3387 53.3149 32.6942C53.9961 31.0496 54.1743 29.24 53.8271 27.4942C53.4798 25.7484 52.6226 24.1447 51.364 22.886C50.1053 21.6274 48.5016 20.7702 46.7558 20.4229C45.01 20.0757 43.2004 20.2539 41.5559 20.9351C39.9113 21.6163 38.5057 22.7698 37.5168 24.2499C36.5278 25.7299 36 27.47 36 29.25C36 31.6369 36.9482 33.9261 38.636 35.614C40.3239 37.3018 42.6131 38.25 45 38.25ZM45 24.75C45.89 24.75 46.76 25.0139 47.5001 25.5084C48.2401 26.0029 48.8169 26.7057 49.1575 27.5279C49.4981 28.3502 49.5872 29.255 49.4135 30.1279C49.2399 31.0008 48.8113 31.8026 48.182 32.432C47.5526 33.0613 46.7508 33.4899 45.8779 33.6635C45.005 33.8372 44.1002 33.7481 43.2779 33.4075C42.4557 33.0669 41.7529 32.4901 41.2584 31.7501C40.7639 31.01 40.5 30.14 40.5 29.25C40.5 28.0565 40.9741 26.9119 41.818 26.068C42.6619 25.2241 43.8065 24.75 45 24.75Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCardManagment);
export default __webpack_public_path__ + "static/media/ic-card-managment.14bc056222fffaa7e5a62e672c9c836b.svg";
export { ForwardRef as ReactComponent };